import Entity from './entity'
import TestQuestion from './testQuestion'

export default class QuestionOfAsk extends Entity<string>{
    title: string;
    content: string;
    questionType: number;
    //是否回复
    isReplay: boolean;
    //回复内容
    replayContent: string;
    creatorUserName: string;
    lastModifierUserName: string;
    createTime: string;
    ip: string;
    testQuestion: TestQuestion = new TestQuestion();
    topSectionName: string;
    subjectName: string;
    questionTypeName: string;
}